module.exports = __webpack_public_path__ + "img/home-bg.f3455666.png";